import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/chat");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <Card className="text-center">
          <CardHeader>
            <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-red-100">
              <Search className="h-10 w-10 text-red-600" />
            </div>
            <CardTitle className="text-3xl font-bold text-gray-900">
              404
            </CardTitle>
            <CardDescription className="text-lg text-gray-600">
              Page Not Found
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-gray-500">
              Sorry, we couldn't find the page you're looking for. The page
              might have been moved, deleted, or you might have entered the
              wrong URL.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Button
                onClick={handleGoHome}
                className="flex items-center gap-2"
              >
                <Home className="h-4 w-4" />
                Go to Chat
              </Button>
              <Button
                variant="outline"
                onClick={handleGoBack}
                className="flex items-center gap-2"
              >
                <ArrowLeft className="h-4 w-4" />
                Go Back
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* Additional helpful links */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500 mb-4">
            Here are some helpful links:
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <button
              onClick={() => navigate("/chat")}
              className="text-blue-600 hover:text-blue-800 hover:underline"
            >
              Chat
            </button>
            <button
              onClick={() => navigate("/projects")}
              className="text-blue-600 hover:text-blue-800 hover:underline"
            >
              Projects
            </button>
            <button
              onClick={() => navigate("/integrations")}
              className="text-blue-600 hover:text-blue-800 hover:underline"
            >
              Integrations
            </button>
            <button
              onClick={() => navigate("/settings")}
              className="text-blue-600 hover:text-blue-800 hover:underline"
            >
              Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
